/**
 * Short human messages for failed organizer-invite calls. The status and body are logged for
 * debugging; the raw body is never shown. Only Composer's one-line validation reasons for admins
 * (for example "already on a paid plan") are passed through, and only when they are short plain text.
 */

const PLAIN_REASON = /^[^<>{}[\]]{1,200}$/;

function shortReason(error) {
  const body = error?.body;
  const detail = body && typeof body === "object" ? (body.detail ?? body.message) : null;
  return typeof detail === "string" && PLAIN_REASON.test(detail.trim()) ? detail.trim() : null;
}

/**
 * @param {unknown} error thrown by apiRequestExternal (carries `status` and `body`)
 * @param {{ context: string, fallback: string, allowReason?: boolean, conflictMessage?: string }} options
 * `conflictMessage` replaces the invitation wording for a 409 that carries no readable reason.
 */
export function organizerInviteErrorMessage(error, { context, fallback, allowReason = false, conflictMessage }) {
  console.error(`[${context}] request failed`, { status: error?.status ?? null, body: error?.body ?? null });
  if (allowReason) {
    const reason = shortReason(error);
    if (reason) {
      return reason;
    }
  }
  const status = error?.status;
  if (status === 409 && conflictMessage) {
    return conflictMessage;
  }
  if (status === 404 || status === 409 || status === 410) {
    return "This invitation is no longer available. Its status may have changed; reload and check.";
  }
  if (status === 401 || status === 403) {
    return "You do not have permission to do that. Sign in again and retry.";
  }
  return fallback;
}
